export class Constants {
  public static clientId = "LoginSPA";


  // Produzione
  private static baseRoot = "https://my.olimpiako.com";

  public static apiRoot = Constants.baseRoot;
  public static authRoot = Constants.baseRoot;
}
